/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { View } from 'react-native';
import Toast from 'react-native-toast-message';
import { isWeb, fullWidth } from '@global/screens';
import Colors from '@global/colors';
import ModalFull from '@components/modal/ModalFull';
import Button from '@components/form/Button';
import Input from '@components/form/Input';
import SociollaText from '@components/sociolla/SociollaText';

import { MsCatalog } from '@api/ms-catalog';
import { showPopup } from '@/store/modal';

const submitStyle = {
  ...(isWeb
    ? {
        width: isWeb ? 'calc(100% - 30px)' : fullWidth - 30,
      }
    : { width: fullWidth - 30 }),
  marginHorizontal: 15,
};

const TextSectionForm = ({
  updateInitBodyText,
  id,
  sectionId = '',
  editData = null,
  show,
  onClose,
  onSubmit,
  onChange,
}) => {
  const dispatch = useDispatch();
  const [bodyText, setBodyText] = useState('');

  useEffect(() => {
    let mounted = true;
    if (mounted && show) {
      if (editData) {
        setBodyText(editData);
      } else {
        setBodyText('');
      }
    }
    return () => {
      mounted = false;
    };
  }, [show]);

  const onSubmitForm = async () => {
    if (!id) {
      updateInitBodyText('text', {
        type: 'text',
        description: bodyText,
      });
      onClose();
      return;
    }
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const payload = {
        description: bodyText,
      };
      let process = null;
      if (editData) {
        process = await MsCatalog.updateCMSSection(
          id,
          'text',
          sectionId,
          payload,
        );
      }
      if (process?.data?.data?._id || process?.data?.success) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        onSubmit();
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  };

  const addNewForm = () => {
    const payload = {
      type: 'text',
      description: bodyText,
    };
    updateInitBodyText('text', payload, true);
    onClose();
  };

  return (
    <ModalFull
      title="Add Text Section"
      show={show}
      back={isWeb ? false : true}
      width={isWeb ? 350 : '100%'}
      onClose={() => onClose()}>
      <View style={{ width: '100%' }}>
        <View style={{ width: '100%', padding: isWeb ? 15 : 20 }}>
          <Input
            label="Bodytext"
            value={bodyText}
            multiline={true}
            numberOfLines={4}
            isRequired={true}
            onChangeText={(value) => setBodyText(value)}
          />
        </View>
        <View
          style={{
            width: '100%',
            paddingVertical: 15,
            justifyContent: 'center',
            borderTopColor: isWeb ? 'transparent' : Colors.grey0,
            borderTopWidth: 1,
          }}>
          <Button
            rounded={true}
            buttonStyle={submitStyle}
            disabledStyle={submitStyle}
            disabled={!bodyText}
            title={
              <SociollaText
                type="bold"
                style={{
                  fontSize: 14,
                  letterSpacing: 0.5,
                  color: Colors.white,
                }}>
                Add
              </SociollaText>
            }
            onPress={() => (editData ? onSubmitForm() : addNewForm())}
          />
        </View>
      </View>
    </ModalFull>
  );
};

export default TextSectionForm;
